import React from 'react';
import Backlinks from './Backlinks';
import useGetCurrentWebsite from '../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite';


export default function BacklinksWrapper() {
    const { website: selectedWebsite } = useGetCurrentWebsite();
    const domain = selectedWebsite?.domain || "";

    return domain ? <Backlinks domain={domain} /> : null
}
